import en from './en.json'
import es from './es.json'

export const messages = {
  en,
  es,
}

export type SupportedLocale = keyof typeof messages
